import React, { useMemo } from "react";
import { SensorDataSessionMarkerFormShape } from "@containers/SensorDataSession/interfaces";
import { Button, ErrorMessageField, Input } from "@shared/components";
import { Formik } from "formik";

import { getInitValues, createValidationSchema } from "./formHelpers";

import "./index.scss";

interface SensorDataSessionMarkerModalProps {
  onClose: () => void;
  onSubmit: (values: SensorDataSessionMarkerFormShape) => void;
}

const SensorDataSessionMarkerModal = (props: SensorDataSessionMarkerModalProps) => {
  const { onClose, onSubmit } = props;

  const initValues = useMemo(() => {
    return getInitValues();
  }, []);

  return (
    <div className="marker-modal modal-content-wrapper">
      <div className="modal-heading">Add New Marker</div>
      <Formik
        validationSchema={createValidationSchema}
        enableReinitialize={true}
        validateOnBlur={false}
        onSubmit={(values, { setSubmitting }) => {
          onSubmit(values);
          setSubmitting(false);
        }}
        initialValues={initValues}
      >
        {({ handleSubmit, handleChange, handleBlur, values }) => (
          <>
            <form onSubmit={handleSubmit}>
              <div className="modal-content">
                <div className="form-description">
                  Please choose the color and the name of your marker before starting marking the dots on the graph.
                </div>
                <div className="form-rows">
                  <div className="color-column">
                    <Input
                      type="color"
                      labelTitle="Color"
                      labelClassName="marker-label"
                      className="marker-color"
                      name="color"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.color}
                      placeholder="Color"
                    />
                    <ErrorMessageField name="color" />
                  </div>
                  <div className="title-column">
                    <Input
                      type="text"
                      labelTitle="Marker Title"
                      labelClassName="marker-label"
                      name="title"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.title}
                      placeholder="Title"
                    />
                    <ErrorMessageField name="title" />
                  </div>
                </div>
              </div>
              <div className="modal-actions">
                <Button appearance="subtle" className="subtle auto-width" onClick={() => onClose()}>
                  Cancel
                </Button>
                <Button type="submit" className="blue auto-width">
                  Create
                </Button>
              </div>
            </form>
          </>
        )}
      </Formik>
    </div>
  );
};

export default SensorDataSessionMarkerModal;
